<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Dashboard</p>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="muven-dashboard-main-filter-modal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Filtro geral do Dashboard</h5>
                    </div>
                    <div class="modal-body">
                        <div>
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label>Data inicial</label>
                                        <v-date-picker 
                                            :input-props="{'class': 'form-control'}" 
                                            popover-visibility="focus"
                                            v-model="generalFilter.date.start" />
                                    </div>
                                </div>

                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label>Data final</label>
                                        <v-date-picker 
                                            :input-props="{'class': 'form-control'}" 
                                            popover-visibility="focus"
                                            v-model="generalFilter.date.end" />
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-show="hasMoreThanOneChannel">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Canais</label>
                                        <multiselect
                                            v-model="generalFilter.channelListWrapper"
                                            :options="channelList"
                                            :multiple="true"
                                            :show-labels="false"
                                            label="name"
                                            track-by="id"
                                            placeholder="">
                                            <template slot="option" slot-scope="{ option }">
                                                <ChannelLogoCmp :channel="option" :size="18" />
                                            </template>
                                            <template slot="tag" slot-scope="{ option, remove }">
                                                <span class="multiselect__tag dashboard-filter-tag">
                                                    <ChannelLogoCmp :channel="option" :size="14" :show-name="false" />
                                                    <span>{{option.name}}</span>
                                                    <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon"
                                                        @keypress.enter.prevent="remove(option)"
                                                        @mousedown.prevent="remove(option)"></i>
                                                </span>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-show="hasMoreThanOneStore">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Lojas</label>
                                        <multiselect
                                            v-model="generalFilter.storeListWrapper"
                                            :options="storeList"
                                            :multiple="true"
                                            :show-labels="false"
                                            label="name"
                                            track-by="id"
                                            placeholder="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" 
                            class="btn btn-primary" 
                            @click="triggerFilters(generalFilter)"
                            :disabled="loadingFilter || !generalFilter.hasDate()">
                                Filtrar

                                <Loading v-show="loadingFilter" />
                        </button>

                        <button type="button" 
                            class="btn btn-outline-secondary" 
                            @click="closeFilterModal()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="muven-content">
            <div class="mb-3">
                <button type="button" 
                    class="btn btn-primary"
                    :disabled="retrivingModalInfoBeforeOpen"
                    @click="showFilterModal()">
                    Filtro

                    <Loading v-show="retrivingModalInfoBeforeOpen" />
                </button>
            </div>

            <div class="dashboard-info-container">
                <div class="mb-3">
                    <DashboardKpiCmp ref="dashboardKpiCmp" />
                </div>

                <div class="floated-layout">
                    <div class="one-third-col">
                        <div class="mb-3">
                            <PendingOrdersIntegrationBackendCmp />
                        </div>

                        <div class="mb-3">
                            <PendingOrdersCmp />
                        </div>

                        <div class="mb-3">
                            <PendingOrdersStatusCmp />
                        </div> 
                    </div>

                    <div class="full-col" v-if="hasMoreThanOneChannel">
                        <div class="mb-3">
                            <SalesBreakdownCmp dimension="channel" :channel-list="channelList" ref="channelSalesCmp" />
                        </div>
                    </div>

                    <div class="left-col">                        
                        <div class="mb-3">
                            <AmountOfSalesCmp ref="amountOfSalesCmp" />
                        </div>
                    </div>

                    <div class="right-col">
                        <div class="mb-3">
                            <AmountOfMoneyEarnedCmp ref="amountOfMoneyEarnedCmp" />
                        </div>
                    </div>

                    <div class="full-col">
                        <div class="mb-3">
                            <AverageTicketCmp ref="averageTicketCmp" />
                        </div>
                    </div>

                    <div class="full-col" v-if="hasMoreThanOneStore">
                        <div class="mb-3">
                            <SalesBreakdownCmp dimension="store" ref="storeSalesCmp" />
                        </div>
                    </div>

                    <div class="left-col">
                        <div class="mb-3">
                            <RegionAmountQuantitySalesCmp ref="regionAmountQuantitySales" />
                        </div>

                        <div class="mb-3">
                            <CategoryAmountQuantitySalesCmp ref="categoryAmountQuantitySales" />
                        </div>
                    </div>

                    <div class="right-col">
                        <div class="mb-3">
                            <RegionAmountMoneySalesCmp ref="regionAmountMoneySales" />
                        </div>

                        <div class="mb-3">
                            <CategoryAmountMoneySalesCmp ref="categoryAmountMoneySales" />
                        </div>
                    </div>                    

                    <div class="full-col">
                        <div class="mb-3">
                            <SalesPeakCmp :is-mobile="isMobileResolution()" ref="salesPeakCmp" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AverageTicketCmp from '@/dashboard/components/AverageTicketCmp'
import SalesPeakCmp from '@/dashboard/components/SalesPeakCmp'
import PendingOrdersCmp from '@/dashboard/components/PendingOrdersCmp'
import PendingOrdersIntegrationBackendCmp from '@/dashboard/components/PendingOrdersIntegrationBackendCmp'
import PendingOrdersStatusCmp from '@/dashboard/components/PendingOrdersStatusCmp'
import AmountOfSalesCmp from '@/dashboard/components/AmountOfSalesCmp'
import AmountOfMoneyEarnedCmp from '@/dashboard/components/AmountOfMoneyEarnedCmp'
import CategoryAmountQuantitySalesCmp from '@/dashboard/components/CategoryAmountQuantitySalesCmp'
import CategoryAmountMoneySalesCmp from '@/dashboard/components/CategoryAmountMoneySalesCmp'
import RegionAmountQuantitySalesCmp from '@/dashboard/components/RegionAmountQuantitySalesCmp'
import RegionAmountMoneySalesCmp from '@/dashboard/components/RegionAmountMoneySalesCmp'
import ChannelLogoCmp from '@/channel/components/ChannelLogoCmp.vue'
import DashboardKpiCmp from '@/dashboard/components/DashboardKpiCmp'
import SalesBreakdownCmp from '@/dashboard/components/SalesBreakdownCmp'
import modalService from '@/utils/services/ModalService'
import { isMobileResolution } from '@/utils/services/ResolutionService'
import { mapGetters, mapState } from 'vuex'
import { StoreModel } from '../../store/models/StoreModel'
import channelService from '../../channel/services/ChannelService'
import { DashboardBaseFilterModel } from '../models/DashboardBaseFilterModel'

const ID_FILTER_MODAL = '#muven-dashboard-main-filter-modal'

export default {
    name: 'DashboardView',
    components: {
        AverageTicketCmp,
        SalesPeakCmp,
        PendingOrdersCmp,
        PendingOrdersIntegrationBackendCmp,
        PendingOrdersStatusCmp,
        AmountOfSalesCmp,
        AmountOfMoneyEarnedCmp,
        CategoryAmountQuantitySalesCmp,
        CategoryAmountMoneySalesCmp,
        RegionAmountQuantitySalesCmp,
        RegionAmountMoneySalesCmp,
        ChannelLogoCmp,
        DashboardKpiCmp,
        SalesBreakdownCmp,
    },
    data() {
        return {
            generalFilter: new DashboardBaseFilterModel(),
            retrivingModalInfoBeforeOpen: false,
            channelList: [],
            chosenChannelList: [],
            chosenStoreList: [],
            loadingFilter: false,
            isMobileResolution,
        }
    },  
    methods: {
        async showFilterModal() {
            this.retrivingModalInfoBeforeOpen = true

            try {
                if (!this.channelList.length) {
                    this.channelList = await channelService.getChannels()
                }

                await modalService.show(ID_FILTER_MODAL)
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.retrivingModalInfoBeforeOpen = false
        },
        async closeFilterModal() {
            await modalService.hide(ID_FILTER_MODAL)
        },
        async triggerFilters(generalFilter) {
            this.loadingFilter = true

            try {
                // Os cards por canal/loja são condicionais: o ref pode não existir.
                const optionalCmps = [this.$refs.channelSalesCmp, this.$refs.storeSalesCmp].filter(Boolean)

                await Promise.all([
                    this.$refs.dashboardKpiCmp.drawGraphic(generalFilter),
                    ...optionalCmps.map((cmp) => cmp.drawGraphic(generalFilter)),
                    this.$refs.averageTicketCmp.drawGraphic(generalFilter),
                    this.$refs.amountOfSalesCmp.drawGraphic(generalFilter),
                    this.$refs.amountOfMoneyEarnedCmp.drawGraphic(generalFilter),
                    this.$refs.salesPeakCmp.drawGraphic(generalFilter),
                    this.$refs.regionAmountQuantitySales.drawGraphic(generalFilter),
                    this.$refs.regionAmountMoneySales.drawGraphic(generalFilter),
                    this.$refs.categoryAmountQuantitySales.drawGraphic(generalFilter),
                    this.$refs.categoryAmountMoneySales.drawGraphic(generalFilter),
                ])
            } catch (err) {
                this.$floatingAlert.info({
                    message: 'Alguns gráficos não foram atualizados.'
                })
            }

            this.loadingFilter = false
            this.closeFilterModal()
        },
    },  
    async mounted() {
        try {
            this.channelList = await channelService.getChannels()
        } catch (err) {
            // Sem canais os cards por canal ficam ocultos; o modal tenta de novo ao abrir.
        }
    },
    computed: {
        ...mapGetters([
            'hasMoreThanOneStore'
        ]),
        ...mapState({
            storeList: (state) => {
                return StoreModel.getStoreListWithIdAndName(state.storeList)
            }
        }),
        hasMoreThanOneChannel() {
            return this.channelList.length > 1
        },
    },
}
</script>

<style lang="scss" scoped>
.dashboard-filter-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.dashboard-info-container ::v-deep {
    .muven-card {
        border-color: var(--border-subtle);
        border-radius: 12px;
        box-shadow: 0 1px 2px color-mix(in srgb, var(--shadow-ink) 4%, transparent), 0 1px 3px color-mix(in srgb, var(--shadow-ink) 3%, transparent);

        .muven-card-title {
            font-size: 15px;
            color: var(--text-strong);
            border-bottom-color: var(--border-subtle);
            border-radius: 12px 12px 0 0;

            .muven-card-subtitle {
                margin-top: 2px;
                font-size: 12px;
                color: var(--text-faint);
            }
        }
    }

    .muven-donut-total {
        display: flex;
        flex-direction: column;
        align-items: center;
        line-height: 1.1;

        .muven-donut-total-label {
            font-size: 11px;
            font-weight: 600;
            letter-spacing: .06em;
            text-transform: uppercase;
            color: var(--text-faint);
        }

        .muven-donut-total-value {
            font-size: 24px;
            font-weight: 700;
            color: var(--text-strong);
        }
    }
}

.dashboard-info-container {
    overflow: hidden;

    .full-col,
    .left-col,
    .right-col {
        float: left;
        width: 100%;
    }

    @media(min-width: 992px) {
        .floated-layout {
            overflow: hidden;

            .one-third-col {
                display: flex;
                justify-content: space-between;
                float: left;
                width: 100%;

                &>div {
                    width: calc(33% - 7px);
                }
            }

            .left-col,
            .right-col {
                width: calc(50% - 7px);
            }

            .left-col {
                margin-right: 7px;
                float: left;
            }

            .right-col {
                margin-left: 7px;
                float: right;
            }
        }

        .full-col {
            width: 100%;
        }
    }
}
</style>
